<div class="container">
  <h3 class="h4 text-success font-weight-bold mb-4">Tabs</h3>
  <div class="row justify-content-center">
    <div class="col-lg-6">
      <!-- Tabs with icons -->
      <div class="mb-3">
        <small class="text-uppercase font-weight-bold">With icons</small>
      </div>
        <ngb-tabset [justify]="'center'" class="custom-tab-content flex-column flex-md-row" type="pills">
            <ngb-tab>
              <ng-template ngbTabTitle>
                <i class="ni ni-cloud-upload-96 mr-2"></i> Home
              </ng-template>
                <ng-template ngbTabContent>
                  <p class="description">Raw denim you probably haven't heard of them jean shorts Austin. Nesciunt tofu stumptown aliqua, retro synth master cleanse. Mustache cliche tempor, williamsburg carles vegan helvetica. Reprehenderit butcher retro keffiyeh dreamcatcher synth.</p>
                  <p class="description">Raw denim you probably haven't heard of them jean shorts Austin. Nesciunt tofu stumptown aliqua, retro synth master cleanse.</p>
                </ng-template>
            </ngb-tab>
            <ngb-tab>
              <ng-template ngbTabTitle>
                <i class="ni ni-bell-55 mr-2"></i> Profile
              </ng-template>
                <ng-template ngbTabContent>
                    <p class="description">Cosby sweater eu banh mi, qui irure terry richardson ex squid. Aliquip placeat salvia cillum iphone. Seitan aliquip quis cardigan american apparel, butcher voluptate nisi qui.</p>
                </ng-template>
            </ngb-tab>
            <ngb-tab>
              <ng-template ngbTabTitle>
                  <i class="ni ni-calendar-grid-58 mr-2"></i> Messages
              </ng-template>
                <ng-template ngbTabContent>
                    <p class="description">Raw denim you probably haven't heard of them jean shorts Austin. Nesciunt tofu stumptown aliqua, retro synth master cleanse. Mustache cliche tempor, williamsburg carles vegan helvetica. Reprehenderit butcher retro keffiyeh dreamcatcher synth.</p>
                </ng-template>
            </ngb-tab>
        </ngb-tabset>
    </div>
    <div class="col-lg-6 mt-5 mt-lg-0">
      <!-- Menu -->
      <div class="mb-3">
        <small class="text-uppercase font-weight-bold">With text</small>
      </div>
      <ngb-tabset [justify]="'center'" class="custom-tab-content flex-column flex-md-row" type="pills">
          <ngb-tab title="Home">
            <ng-template ngbTabContent>
              <p class="description">Raw denim you probably haven't heard of them jean shorts Austin. Nesciunt tofu stumptown aliqua, retro synth master cleanse. Mustache cliche tempor, williamsburg carles vegan helvetica. Reprehenderit butcher retro keffiyeh dreamcatcher synth.</p>
              <p class="description">Raw denim you probably haven't heard of them jean shorts Austin. Nesciunt tofu stumptown aliqua, retro synth master cleanse.</p>
            </ng-template>
          </ngb-tab>
          <ngb-tab title="Profile">
            <ng-template ngbTabContent>
                <p class="description">Cosby sweater eu banh mi, qui irure terry richardson ex squid. Aliquip placeat salvia cillum iphone. Seitan aliquip quis cardigan american apparel, butcher voluptate nisi qui.</p>
            </ng-template>
          </ngb-tab>
          <ngb-tab title="Messages">
            <ng-template ngbTabContent>
                <p class="description">Raw denim you probably haven't heard of them jean shorts Austin. Nesciunt tofu stumptown aliqua, retro synth master cleanse. Mustache cliche tempor, williamsburg carles vegan helvetica. Reprehenderit butcher retro keffiyeh dreamcatcher synth.</p>
            </ng-template>
          </ngb-tab>
      </ngb-tabset>
    </div>
  </div>

  <div class="row row-grid justify-content-between align-items-center mt-lg">
    <div class="col-lg-5">
      <h3 class="h4 text-success font-weight-bold mb-4">Progress bars</h3>
      <div class="progress-wrapper">
        <div class="progress-info">
          <div class="progress-label">
            <span>Task completed</span>
          </div>
          <div class="progress-percentage">
            <span>40%</span>
          </div>
        </div>
        <ngb-progressbar type="default" [value]="25"></ngb-progressbar>
      </div>
      <div class="progress-wrapper">
        <div class="progress-info">
          <div class="progress-label">
            <span>Task completed</span>
          </div>
          <div class="progress-percentage">
            <span>60%</span>
          </div>
        </div>
        <ngb-progressbar type="primary" [value]="60"></ngb-progressbar>
      </div>
    </div>
    <div class="col-lg-5">
      <h3 class="h4 text-success font-weight-bold mb-5">Pagination</h3>
      <nav aria-label="Page navigation example" class="mb-4">
        <ngb-pagination [collectionSize]="50" [(page)]="page" [directionLinks]="false"></ngb-pagination>
      </nav>
      <nav aria-label="Page navigation example">
        <ngb-pagination [collectionSize]="50" [(page)]="page1" aria-label="Default pagination">
          <ng-template ngbPaginationPrevious><i _ngcontent-c9="" class="fa fa-angle-left"></i></ng-template>
          <ng-template ngbPaginationNext><i _ngcontent-c9="" class="fa fa-angle-right"></i></ng-template>
        </ngb-pagination>
      </nav>
    </div>
  </div>
  <div class="row row-grid justify-content-between">
    <div class="col-lg-5">
      <h3 class="h4 text-success font-weight-bold mb-5">Navigation Pills</h3>
      <ngb-tabset type="pills" class="nav-pills-circle">
          <ngb-tab>
            <ng-template ngbTabTitle>
              <span class="nav-link-icon d-block"><i class="ni ni-atom"></i></span>
            </ng-template>
          </ngb-tab>
          <ngb-tab>
            <ng-template ngbTabTitle>
              <span class="nav-link-icon d-block"><i class="ni ni-chat-round"></i></span>
            </ng-template>
          </ngb-tab>
          <ngb-tab>
            <ng-template ngbTabTitle>
                <span class="nav-link-icon d-block"><i class="ni ni-cloud-download-95"></i></span>
            </ng-template>
          </ngb-tab>
      </ngb-tabset>
    </div>
    <div class="col-lg-5">
      <h3 class="h4 text-success font-weight-bold mb-5">Labels</h3>
      <span class="badge badge-pill badge-primary text-uppercase">Primary</span>
      <span class="badge badge-pill badge-success text-uppercase">Success</span>
      <span class="badge badge-pill badge-danger text-uppercase">Danger</span>
      <span class="badge badge-pill badge-warning text-uppercase">Warning</span>
      <span class="badge badge-pill badge-info text-uppercase">Info</span>
    </div>
  </div>
</div>
